/** Some response writes (Review Responses / Nomination Responses) were refused; the others were saved (their row IDs are kept). */
export class OEPPartialSaveError extends Error {
    constructor(message: string, public readonly FailedQuestionIDs: readonly string[]) {
        super(message);
        this.name = 'OEPPartialSaveError';
    }
}
